import React, { useState, useEffect } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminTopBar from "./AdminTopBar";
import { useNavigate } from "react-router-dom";
import api from "./api/axios"; // Import your custom API instance
import { useActivityLogger } from "./hooks/useActivity"; // Custom hook for logging activities
import { useSearch } from "./contexts/SearchContext";
export default function AdminVideo() {
  const { searchQuery } = useSearch();

  const [videos, setVideos] = useState([]); // Store videos from API
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  const navigate = useNavigate();
  const { logAdminActivity } = useActivityLogger(); // Custom hook for logging activities
  // Fetch the videos from the API when the component is mounted
  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const res = await api.get("/youtube/videos");
        setVideos(res.data); // Set videos from API response
      } catch (error) {
        console.error("Gagal mengambil video:", error);
        alert("Terjadi kesalahan saat mengambil video.");
      }
    };
    logAdminActivity(
      "view",
      "view_admin_video_list",
      "video",
      null,
      "admin",
      "success",
      "",
      "Admin membuka daftar video edukasi",
    );
    fetchVideos();
  }, []);
  const filteredVideos = videos.filter(video =>
    video.title?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    video.sumber?.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredVideos.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredVideos.length / itemsPerPage);

  // Handle video deletion
  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Apakah Anda yakin ingin menghapus video ini?",
    );
    if (!confirmDelete) return;

    try {
      await api.delete(`/youtube/video/${id}`);
      // Filter out the deleted video from the state
      setVideos((prevVideos) => prevVideos.filter((video) => video.ID !== id));
      logAdminActivity(
        "delete",
        "delete_admin_video",
        "video",
        id,
        "",
        "success",
        "",
        `Admin menghapus video dengan ID ${id}`,
      );
      alert("Video berhasil dihapus!");
    } catch (error) {
      console.error("Gagal menghapus video:", error);
      alert("Terjadi kesalahan saat menghapus video.");
    }
  };

  return (
    <div className="min-h-screen flex">
      <AdminSidebar />
      <div className="flex-1 p-6 bg-gray-50">
        <AdminTopBar />

        <div className="bg-white p-4 rounded shadow">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-lg font-semibold">Video Edukasi</h2>
            <button
              onClick={() => navigate("/admin/video/upload")}
              className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
            >
              + Upload Video
            </button>
          </div>

          <table className="w-full text-sm">
            <thead className="border-b">
              <tr>
                <th className="py-2 text-left">Waktu Upload</th>
                <th className="py-2 text-left">Kategori</th>
                <th className="py-2 text-left">Thumbnail</th>
                <th className="py-2 text-left">Judul</th>
                <th className="py-2 text-left">Sumber</th>
                <th className="py-2"></th>
              </tr>
            </thead>
            <tbody>
              {currentItems.map((video) => (
                <tr key={video.ID} className="border-b">
                  <td className="py-2">
                    {new Date(video.publishedAt).toLocaleDateString("id-ID")}
                  </td>
                  <td className="py-2">
                    {/* {new Date(video.UpdatedAt).toLocaleDateString("id-ID")} */}
                    {video.kategori}
                  </td>
                  <td className="py-2">
                    <img
                      src={video.thumbnail}
                      alt={video.title}
                      className="h-20 rounded"
                    />
                  </td>
                  <td className="py-2">{video.title}</td>
                  <td className="py-2">{video.sumber}</td>
                  <td className="py-2 align-middle">
                    <div className="flex items-center gap-2">
                      <button
                        onClick={() =>
                          navigate(`/admin/video/edit/${video.ID}`)
                        }
                      >
                        <img
                          src="/icon-edit.png"
                          alt="Edit"
                          className="h-5 w-5"
                        />
                      </button>
                      <button onClick={() => handleDelete(video.ID)}>
                        <img
                          src="/icon-trash.png"
                          alt="Delete"
                          className="h-5 w-5"
                        />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="flex justify-end mt-4 gap-1">
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              className="border px-2 py-1 rounded"
            >
              &lt;
            </button>
            {[...Array(totalPages)].map((_, i) => (
              <button
                key={i + 1}
                onClick={() => setCurrentPage(i + 1)}
                className={`border px-2 py-1 rounded ${currentPage === i + 1 ? "bg-blue-500 text-white" : ""}`}
              >
                {i + 1}
              </button>
            ))}
            <button
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              className="border px-2 py-1 rounded"
            >
              &gt;
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
